import { api_host } from "../../common/globals/constants";
import { getObjectivesIgnoreCache } from "../getObjectives";
import queryString from "query-string";

function getApiKeys() {
    const token = sessionStorage.getItem("key");
    const user = sessionStorage.getItem("user");

    return { token, user };
}

export function createMarkePeriod(markedPeriod) {
    const { token } = getApiKeys();
    return fetch(`${api_host}/reporte/general/periodo_marcado/?token=${token}`, {
        method: "POST",
        body: JSON.stringify({ token, ...markedPeriod }),
        headers: {
            "Content-Type": "application/json",
        },
    });
}

export function updateMarkePeriod(markedPeriod) {
    const { token } = getApiKeys();
    return fetch(`${api_host}/reporte/general/periodo_marcado/?token=${token}`, {
        method: "PATCH",
        body: JSON.stringify({ token, ...markedPeriod }),
        headers: {
            "Content-Type": "application/json",
        },
    });
}

export function deleteMarkePeriod(markedPeriod) {
    const { token } = getApiKeys();
    return fetch(`${api_host}/reporte/general/periodo_marcado/?token=${token}`, {
        method: "DELETE",
        body: JSON.stringify({ token, ...markedPeriod }),
        headers: {
            "Content-Type": "application/json",
        },
    });
}
